export default __webpack_public_path__ + "static/10 years in business-df63dec55bc1d859e08b31d420fe5760.svg";